let exports = {
	key_val: {
		forms: [
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12 col-md-4',
				model: 'name',
				validation: 'required|min:3|max:200',
				label: 'Name',
			},
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12 col-md-4',
				model: 'value',
				validation: 'required|min:3|max:200',
				label: 'Value',
			},
		],
		table: {
			icon: 'fa fa-sitemap',
			title: 'Items',
			table_fields: [
				{ name: 'Name', align: 'c' },
				{ name: 'Value', align: 'c' },
				{ name: 'Actions', align: 'c' },
			],
			search_fields: ['name', 'value'],
			row_data: [
				{ type: 'text', field: 'name', class: 'bold center' },
				{ type: 'text', field: 'value', class: 'small center' },
				{
					type: 'action',
					field: 'name',
					class: 'center',
					icon: '',
					actions: [
						// {type: 'title', title: 'Actions'},
						{ type: 'menu', title: 'View', event: 'table:view' },
						{
							type: 'menu',
							title: 'Delete',
							event: 'table:delete',
							icon: 'fa-trash-alt',
						},
					],
				},
			],
		},
	},
};

let forms = {
	request_quote: {
		icon: 'fa fa-user',
		title: 'Request IPF',
		subtitle: 'Request bank ipf',
		forms: [
			{
				type: 'upload',
				class: 'col-12',
				model: 'docs',
				validation: '',
				label: 'Upload Logbook',
				accept: '*',
				multiple: false,
			},
			// {
			//    type: 'form-table',forms: exports.key_val.forms, table: exports.key_val.table,class: 'col-12',label: 'Other Details e.g Name: make, Value: brown',model: 'items', placeholder: 'e.g Name: make, Value: brown'
			// },
			{
				type: 'text',
				form_type: 'number',
				class: 'col-12',
				model: 'sum_assured',
				validation: 'required|numeric|min:1',
				label: 'Sum Assured',
				placeholder: 'Enter details',
			},
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'reg_no',
				validation: 'required',
				label: 'Registration Number',
				placeholder: 'Enter details',
			},
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'engine_capacity',
				validation: 'required',
				label: 'Engine Capacity',
				placeholder: 'Enter details',
			},
		],
	},
	select_category: {
		icon: 'fa fa-user',
		title: 'Request IPF',
		subtitle: 'Request bank ipf',
		forms: [
			{
				type: 'select',
				class: 'col-12',
				model: 'insurance_category',
				filterable: true,
				clearable: true,
				options: [],
				validation: 'required',
				label: 'Product Catalogue',
			},
			{
				type: 'select',
				class: 'col-12',
				model: 'request_option',
				filterable: true,
				clearable: true,
				options: [
					{ val: 'customized', label: 'Online Quotation' },
					{ val: 'free', label: 'Request For Quotation' },
				],
				validation: 'required',
				label: 'Request Option',
			},
		],
	},
	chat_users: {
		icon: 'fa fa-user',
		title: 'Request IPF',
		subtitle: 'Request bank ipf',
		forms: [
			{
				type: 'select',
				class: 'col-12',
				model: 'chat_user',
				filterable: true,
				clearable: true,
				options: [],
				validation: 'required',
				label: 'User',
			},
		],
	},
	accept_terms: {
		icon: 'fa fa-user',
		title: 'Request IPF',
		subtitle: 'Request bank ipf',
		forms: [
			{
				type: 'textarea',
				class: 'col-12',
				model: 'remarks',
				rows: '4',
				validation: 'required',
				label: 'Remarks',
			},
			// {
			//    type: 'radio', class: 'col-12 funkyradio', elClass: 'funkyradio', model: 'termsDownload', label: 'Terms and Conditions', validation: 'required',
			//    options: [
			//       { val: 'download', label: 'Download' },
			//       { val: 'email', label: 'Send via email' },
			//    ], classes: { radioRow: 'row', radioCol: 'col-12 col-md-6 col-lg-4' }
			// },
			{
				type: 'checkbox',
				class: 'col-12 custom-check',
				model: 'terms',
				validation: 'required',
				label: 'I agree to the <a href="https://agency.nexus.ke/static/media/Nexus%20General%20Terms%20and%20Conditions%2027.7.2020.fa4a0a2ac647c2df199c.pdf" target="_blank">terms and conditions</a>',
			},
		],
	},
	appointment_form: {
		icon: 'fa fa-user',
		title: 'Intermediary Appointment',
		subtitle: 'Book an appointment',
		forms: [
			{
				type: 'datepicker',
				form_type: 'date',
				format: 'dd-MM-yyyy',
				placement: 'bottom-end',
				model: 'date',
				label: 'Appointment Date',
				class: 'col-12 col-md-6',
				validation: 'required',
			},
			{
				type: 'datepicker',
				form_type: 'time',
				format: 'HH:mm',
				placement: 'bottom-end',
				model: 'time',
				label: 'Appointment Time',
				class: 'col-12 col-md-6',
				validation: 'required',
			},
			{
				type: 'text',
				class: 'col-12',
				model: 'subject',
				form_type: 'text',
				validation: 'required|min:3|max:150',
				label: 'Subject',
			},
			{
				type: 'textarea',
				class: 'col-12',
				model: 'description',
				rows: '4',
				validation: 'required|min:10|max:500',
				label: 'Description',
			},
		],
	},
};

module.exports = {
	forms: utils.generateAllFormData(forms),
};
